import React from "react";

const TableListPaging = (props) => {
    const {onBack, onNext} = props

    return <>
        <ul className='pagination pagination-sm float-right'>
            <li className='page-item'>
                <button className='page-link' type={'button'}
                        onClick={() => onBack()}>&laquo;</button>
            </li>
            <li className='page-item'>
                <button className='page-link' type={'button'}
                        onClick={() => onNext()}>&raquo;</button>
            </li>
        </ul>
    </>
}

export default TableListPaging;
